import { type User } from '@app/client/common/structs/user/user';
import { useAuthTokens } from '@app/store/zustand/Auth/useUserTokens';

import { useGetGroupMembers } from './useGetGroupMembers';
import { useGroupId } from './useGroupId';
import { getPagesContent } from './utils';

/**
 * React Hook to retrieve the `GroupMember` that
 * corresponds with a `userId`.
 */
export function useGetGroupMemberByUserId(userId: User['id'] | undefined) {
    const isAuthenticated = useAuthTokens((state) => state.isAuthenticated);

    const groupId = useGroupId();
    const { data } = useGetGroupMembers({ isAuthenticated, groupId });

    const membersData = getPagesContent(data?.pages);
    return userId && membersData ? membersData.find((member) => member.user_id === userId) : undefined;
}
